import { GetServerSidePropsContext } from 'next';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { store, StoreContext } from 'stores/store';
import ConnectWrapper from 'templates/Connect/ConnectWrapper';
import { IAuthDetails, verifyAuth } from 'utils/authUtils';
import { getConfigEntry } from 'utils/contentClient';
import { IResourceData } from 'utils/globalTypes';
import UseSsrAuth from 'utils/hooks/useSsrAuth';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { getObjProperty } from 'utils/object';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_DOMAIN } = publicRuntimeConfig;

function ConnectPage({
  images,
  authDetails
}: {
  images?: IResourceData[];
  authDetails: IAuthDetails;
}) {
  const title = 'USREM | Connect';
  const url = `https://${NEXT_PUBLIC_DOMAIN}/connect`;
  const description = 'Connect to USREM | USREM';

  const clientAuthDetails = useUserAuth();

  useEffect(() => {
    verifyAuth(authDetails, clientAuthDetails);
  }, [authDetails, clientAuthDetails]);

  return (
    <>
      <NextSeo
        title={title}
        canonical={url}
        openGraph={{
          title: title,
          url: url,
          description
        }}
      />
      <StoreContext.Provider value={{ ...store }}>
        <ConnectWrapper images={images} />
      </StoreContext.Provider>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const authProps = await UseSsrAuth(ctx);
  const content = await getConfigEntry('pages/connect');
  const connectImages = getObjProperty(content as Record<string, unknown>, 'gallery') || [];

  return {
    props: { ...authProps.props, images: connectImages ?? null }
  };
}

export default ConnectPage;
